<script setup lang="ts">
defineEmits<{
  setDefault: [value: string | number];
}>();

const { value, defaultValue } = defineProps<{
  title: string;
  label: string;
  value: string | number;
  defaultValue: string | number | null;
}>();

const isChangeable = computed(() => {
  return value !== defaultValue;
});
</script>

<template>
  <div class="grid grid-cols-4">
    <div class="col-span-1 text-sm text-gray-900" data-title>{{ title }}</div>
    <div class="col-span-3 flex">
      <div class="text-sm text-gray-900">{{ label }}</div>
      <div class="ml-auto flex-none text-sm">
        <button
          v-if="isChangeable"
          type="button"
          class="text-blue-600 underline decoration-blue-600 hover:text-blue-400 hover:decoration-blue-400"
          @click="$emit('setDefault', value)"
        >
          設定する
        </button>
        <div v-else class="text-gray-600">設定済み</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
[data-title]::after {
  content: ':';
  margin-right: 0.5rem;
}
</style>
